import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Form,
  Input,
  Modal,
  Spin,
  Typography,
} from 'antd';
import { ArrowLeftOutlined, CheckOutlined } from '@ant-design/icons';
import FormSubmitCustomControls from 'components/FormSubmitCustomControls';

/**
 * Confirmación de una acción masiva que pide la contraseña del usuario (reautenticación).
 * La contraseña solo vive en el formulario del modal: se limpia al abrir, al fallar y al cerrar.
 */
const ModalConfirmacionConContrasena = ({
  visible,
  mensaje,
  alerta,
  onRegresar,
  onConfirmar,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    form.resetFields();
    setError(null);
  }, [visible]);

  const onAceptar = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    setLoading(true);
    setError(null);
    // onConfirmar regresa { ok, error }; si falla se queda abierto para reintentar
    const resultado = await onConfirmar(values.password);
    setLoading(false);
    if (!resultado?.ok) {
      form.resetFields(['password']);
      setError(resultado?.error || null);
    }
  };

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={!loading}
      width={520}
      centered
      title={(
        <FormSubmitCustomControls
          label="Confirmación"
          loading={loading}
          controls={[
            { text: 'Regresar', icon: <ArrowLeftOutlined />, onClick: onRegresar },
            { text: 'Aceptar', icon: <CheckOutlined />, onClick: onAceptar },
          ]}
        />
      )}
    >
      <Spin tip="Procesando..." spinning={loading}>
        {typeof mensaje === 'string'
          ? <Typography.Paragraph>{mensaje}</Typography.Paragraph>
          : mensaje}
        {!!alerta && (
          <Alert type="warning" showIcon style={{ marginBottom: 12 }} message={alerta} />
        )}
        {!!error && (
          <Alert type="error" showIcon style={{ marginBottom: 12 }} message={error} />
        )}
        <Form form={form} layout="vertical" onFinish={onAceptar}>
          <Form.Item
            name="password"
            label="Contraseña (confirme con la contraseña de su usuario)"
            rules={[{ required: true, message: 'Capture su contraseña' }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

ModalConfirmacionConContrasena.propTypes = {
  visible: PropTypes.bool.isRequired,
  mensaje: PropTypes.node.isRequired,
  alerta: PropTypes.node,
  onRegresar: PropTypes.func.isRequired,
  // Recibe la contraseña y regresa { ok, error }
  onConfirmar: PropTypes.func.isRequired,
};

ModalConfirmacionConContrasena.defaultProps = {
  alerta: null,
};

export default ModalConfirmacionConContrasena;
